import { directusApi } from '@/api';
import { Data } from '@/models/data.model';
import lodash from 'lodash';
export interface ProductApplication {
    id?: number;
    slug: string;
    name: string;
}

export interface ProductApplicationState {
    allProductApplications: Array<ProductApplication>;
    allProductApplicationsLoading: boolean;

    activeProductApplication: ProductApplication | null;
    activeProductApplicationLoading: boolean;
}

const state: ProductApplicationState = {
    allProductApplications: [],
    allProductApplicationsLoading: false,

    activeProductApplication: {
        id: 0,
        slug: '',
        name: ''
    },
    activeProductApplicationLoading : false
};

const defaultProductApplication = {
    id: 0,
    slug: '',
    name: ''
}

const mutations = {
    TOGGLE_ALL_APPLICATIONS_LOADING(state: ProductApplicationState, data: boolean) {
        state.allProductApplicationsLoading = data;
    },
    SET_ALL_APPLICATIONS(state: ProductApplicationState, data: Array<ProductApplication>) {
        state.allProductApplications = data;
    },
    TOGGLE_ACTIVE_PRODUCT_APPLICATION_LOADING(state: ProductApplicationState, data: boolean){
        state.activeProductApplicationLoading = data;
    },
    REMOVE_PRODUCT_SECTOR(state: ProductApplicationState, id: number) {
        state.allProductApplications = lodash.remove(state.allProductApplications, function (n) {
            return n.id != id;
        });
    },
    SET_ACTIVE_PRODUCT_APPLICATION(state: ProductApplicationState, data: ProductApplication){
        state.activeProductApplication = {...data};
    }
};

const actions = {
    async getAll({ _, commit }: any, data: Data | null) {
        let params = '';
        if (data) params += `&search=${data.search}`;
        params += '&limit=200&meta=total_count&sort=name';
        commit('TOGGLE_ALL_APPLICATIONS_LOADING', true);
        await directusApi('GET', `items/products_applications?${params}`)
            .then(res => {
                commit('SET_ALL_APPLICATIONS', res.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ALL_APPLICATIONS_LOADING', false);
            });
    },
    async getOne({ _, commit }: any, id: any | null = null) {
        commit('TOGGLE_ACTIVE_PRODUCT_APPLICATION_LOADING', true);
        if (id) {
            await directusApi('GET', `items/products_applications/${id}`)
            .then(res => {
                commit('SET_ACTIVE_PRODUCT_APPLICATION', res.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ACTIVE_PRODUCT_APPLICATION_LOADING', false);
            });   
        } else {
            commit('SET_ACTIVE_PRODUCT_APPLICATION', defaultProductApplication);
            commit('TOGGLE_ACTIVE_PRODUCT_APPLICATION_LOADING', false);
        }
    },
    async postOne({ _, commit }: any, data: any) {
        commit('TOGGLE_ACTIVE_PRODUCT_APPLICATION_LOADING', true);
        await directusApi('POST', `items/products_applications`, {
            name: data.data.name,
            slug: data.data.slug
        })
        .then(async (application: any) => {
            data.vm.$bvToast.toast('Se ha creado exitosamente', {
                title: `Aplicación creada`,
                variant: 'success',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
            commit('SET_ACTIVE_PRODUCT_APPLICATION', application.data.data);
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            commit('TOGGLE_ACTIVE_PRODUCT_APPLICATION_LOADING', false);
        });
    },
    async putOne({ _, commit }: any, data: any) {
        commit('TOGGLE_ACTIVE_PRODUCT_APPLICATION_LOADING', true);
        await directusApi('PATCH', `items/products_applications/${data.data.id}`, {
            name: data.data.name,
            slug: data.data.slug
        })
        .then(async (application: any) => {
            data.vm.$bvToast.toast('Se ha actualizado exitosamente', {
                title: `Aplicación actualizada`,
                variant: 'success',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
            commit('SET_ACTIVE_PRODUCT_APPLICATION', application.data.data);
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            commit('TOGGLE_ACTIVE_PRODUCT_APPLICATION_LOADING', false);
        });
    },
    async deleteOne({ _, commit }: any, data: any) {
        commit('TOGGLE_ACTIVE_PRODUCT_APPLICATION_LOADING', true);
        await directusApi('DELETE', `items/products_applications/${data.id}`, {})
        .then(async (res: any) => {
            data.vm.$bvToast.toast('Se ha eliminado exitosamente', {
                title: `Aplicación eliminada`,
                variant: 'success',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
            commit('REMOVE_PRODUCT_SECTOR', data.id);
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            commit('TOGGLE_ACTIVE_PRODUCT_APPLICATION_LOADING', false);
        });
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
